// extracted by mini-css-extract-plugin
export default {"spinner-space":"DatasetCatalog_spinner-space__7GC8j","table-cell":"DatasetCatalog_table-cell__RdYMI","table-logo":"DatasetCatalog_table-logo__+FoBc"};